module.exports = __webpack_public_path__ + "a4ad9705eea26c2b6cebf824ebceb2b6.gif";